import { useEffect } from 'react';
import './nominet.css';

export function NominetCss () {
  useEffect(() => {
    const cookieyesScript = document.createElement('script');
    cookieyesScript.id = 'cookieyes';
    cookieyesScript.src = 'https://cdn-cookieyes.com/client_data/db411cf4c6a62295e776d292/script.js';
    cookieyesScript.async = true;
    document.body.appendChild(cookieyesScript);

    const gTagManagerScript = document.createElement('script');
    gTagManagerScript.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-M7SW6TSS');`
    document.head.appendChild(gTagManagerScript);

    const gTagManagerNoScript = document.createElement('noscript');
    gTagManagerNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-M7SW6TSS" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    document.body.prepend(gTagManagerNoScript);
  }, []);
  return null;
}
